<template>
  <b-modal
    :id="modalUniqueId"
    :modal-class="modalClasses"
    :hide-footer="true"
    @hidden="hide"
    @shown="shown"
  >
    <template v-slot:modal-title>
      Compartilhar
    </template>

    <template v-slot:default>
      <AlertWraper
        :content="errors"
        type="error"
      />
      <div class="wrapper" v-if="shortUri">
        <div class="d-flex align-items-center item rounded-regular p-2 mb-4">
          <div
            class="image rounded-regular background-cover"
            :style="{ backgroundImage: `url('${target.cover}')` }"
          ></div>
          <div class="content pl-2 d-flex align-items-center">
              <span class="font-size-small">{{ target.title || target.name }}</span>
          </div>
        </div>
        <div class="mb-4">
          <h2 :class="[nightMode ? 'text-color1' : 'text-color2']" class="font-weight-bold font-size-small mb-3">Link para compartilhar</h2>
          <input
              type="text"
              class="form-control bordered-bottom font-size-small text-center link-input"
              readonly="true"
              :value="postUri.uri"
              ref="link"
          />
          <Button
              class="btn btn-sm btn-outline-color2 px-2 hover-color-white col-md-3 col-md-offset-2"
              @click="copyURL"
          >
              Copiar link
          </Button>
          <v-tooltip
            v-if="showTooltip"
            bottom
          >
            <span class="font-size-xSmall text-center text-color2">Link copiado!</span>
          </v-tooltip>
        </div>
        <div class="mb-4">
          <h2 :class="[nightMode ? 'text-color1' : 'text-color2']" class="font-weight-bold font-size-small mb-3">Compartilhar nas redes sociais</h2>
          <ul class="d-flex justify-content-center align-items-center mb-0 social-listing">
              <li class="mr-4">
                <a class="rounded-xl bordered-1 border-color2 text-color2 social-icon" :href="postUri.shareFb" target="_blank" title="Compartilhar no Facebook">
                  <i class="fa fa-facebook"></i>
                </a>
              </li>
              <li class="mr-4">
                <a class="rounded-xl bordered-1 border-color2 text-color2 social-icon" :href="postUri.shareTwitter" target="_blank" title="Compartilhar no Twitter">
                  <i class="fa fa-twitter"></i>
                </a>
              </li>
              <li class="mr-4">
                <a class="rounded-xl bordered-1 border-color2 text-color2 social-icon" :href="postUri.shareWhatsapp" target="_blank" title="Compartilhar via Whatsapp">
                  <i class="fa fa-whatsapp"></i>
                </a>
              </li>
          </ul>
        </div>
      </div>
      <div v-else>
        <Loader
          color="color2"
          size="big"
        />
      </div>
    </template>
  </b-modal>
</template>

<script>

import { parseErrorResponseToArray } from '@/utils'
import { mapState } from 'vuex'

import PostsService from '@/modules/posts/services/posts-service'
import AlertWraper from '@/components/common/Alert/AlertWraper.vue'
import Loader from '@/components/common/Loader/Loader.vue'

export default {
  name: 'ShareModal',
  props: ['target', 'type', 'modalId'],
  components: {
    AlertWraper,
    Loader
  },
  data () {
    return {
      errors: null,
      showTooltip: false,
      shortUri: null
    }
  },
  computed: {
    ...mapState({
      nightMode: state => state.nightMode
    }),
    modalClasses () {
      return {
        'default-modal': true
      }
    },
    postUri () {
      return {
        uri: this.shortUri,
        shareTwitter: 'https://twitter.com/intent/tweet?text=' + encodeURI(this.target.title + ' por ' + this.target.user.name) + '&via=scrivapp&url=' + encodeURI(this.shortUri),
        shareFb: 'https://www.facebook.com/sharer.php?u=' + encodeURI(this.shortUri),
        shareWhatsapp: 'https://api.whatsapp.com/send?text=' + encodeURI(this.target.title + ' por ' + this.target.user.name + ' ' + this.shortUri)
      }
    },
    permalink () {
      const route = {}
      if (this.type === 'chapter') {
        route.name = 'chapters.show'
        route.params = { username: this.target.user.username, bookSlug: this.target.book.slug, slug: this.target.slug }
      } else if (this.type === 'post') {
        route.name = 'posts.show'
        route.params = { username: this.target.user.username, slug: this.target.slug }
      } else if (this.type === 'group') {
        route.name = 'groups.show'
        route.params = { slug: this.target.slug }
      } else if (this.type === 'category') {
        route.name = 'categories.show'
        route.params = { username: this.target.user.username, slug: this.target.slug }
      } else {
        route.name = 'books.show'
        route.params = { username: this.target.user.username, slug: this.target.slug }
      }
      const props = this.$router.resolve(route)
      return window.location.origin + props.href
    },
    modalUniqueId () {
      if (this.modalId) {
        return this.modalId
      } else {
        return 'share-' + this.type + '-' + this.target.id
      }
    }
  },
  methods: {
    copyURL () {
      this.$refs.link.select()
      document.execCommand('copy')
      this.showTooltip = true
    },
    hide () {
      this.errors = null
      this.showTooltip = false
      this.$bvModal.hide(this.modalUniqueId)
    },
    async getShortUrl () {
      if (!this.shortUri) {
        try {
          const obj = await PostsService.createShortUrl(this.permalink)
          this.shortUri = obj.short_link
        } catch (error) {
          this.errors = parseErrorResponseToArray(error)
        }
      }
    },
    async shown () {
      await this.getShortUrl()
    }
  }
}
</script>

<style lang="scss" scoped>
input{
    &.link-input{
        @include desktop{
            width: 70%;
        }
    }
}
.image {
  width: 60px;
  height: 40px;
}
.content {
  flex-grow: 1;
}
</style>
